type Settings = {};

export let settings: Settings = {} as Settings;

export async function getSettings(): Promise<void> {
  settings = {} as Settings;
}
